import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge } from "reactstrap"
import { post } from "../../../helpers/api_helper";
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { toImageUrl } from "helpers/file_upload_helper";
import { VEHICLE_CATEGORY_SEARCH } from "helpers/api_endpoints";
import NoImage from "assets/images/no-image.png";
//meta title
document.title = "Vehicles";
const VehicleCategoriesList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(true);
    const [vehicle_categories, setVehiceCategories] = useState([]);
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        post(`${VEHICLE_CATEGORY_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
            .then(response => {
                const data = response.data;
                setVehiceCategories(data.data);
                setTotalPages(data.pagination.totalPages);
                setPage(data.pagination.currentPage);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })
    }, [page, filters]);

    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                location.state.successMessage = '';
                setsuccessMsg('');
            }, 4000)
        }
    };

    const handleFilter = (type, value) => {
        const filtvalues = {};
        if (value) {
            switch (type) {
                case 'name':
                    setName(value);
                    filtvalues.name = value;
                    break;
                default:
                    break;
            }
        }
        setFilters(filtvalues);
    }

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Vehicle Categories" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <CardTitle>
                                    <Link to="/vehicle-categories/add" >
                                        <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                    </Link>
                                </CardTitle>

                                <div style={{ margin: "25px" }}>
                                    <div className="row">
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                name="name"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('name', e.target.value)}
                                                onKeyDown={(e) => handleFilter('name', e.target.value)}
                                            ></Input>
                                        </div>
                                    </div>
                                </div>


                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>ID</Trans></th>
                                                    <th className="text-center"><Trans>Image</Trans></th>
                                                    <th><Trans>Name</Trans></th>
                                                    <th><Trans>Shipment Types</Trans></th>
                                                    <th><Trans>Title</Trans></th>
                                                    <th><Trans>Sub Title</Trans></th>
                                                    <th><Trans>Color</Trans></th>
                                                    <th><Trans>Capacity</Trans></th>
                                                    <th><Trans>Status</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={10} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    vehicle_categories.map((vehicle_category, index) => (
                                                        <tr key={index}>
                                                            <td>{vehicle_category.id}</td>
                                                            <td className="text-center">{(vehicle_category.image) ? <img style={{ background: "#f5f5f5", padding: "15px", borderRadius: "5px" }} src={toImageUrl(vehicle_category.image)} width={80}></img> : <img src={NoImage} width={70} style={{ background: "#f5f5f5", padding: "8px", borderRadius: "5px" }}></img>}</td>
                                                            <td>{vehicle_category.name}</td>
                                                            <td>{(vehicle_category.ShipmentTypes || []).map(el => el.name).join(', ')}</td>
                                                            <td>{vehicle_category.title}</td>
                                                            <td>{vehicle_category.subTitle}</td>
                                                            <td>{vehicle_category.color}</td>
                                                            <td>{vehicle_category.capacity}</td>
                                                            <td>{(vehicle_category.status == 1) ? <Badge className="bg-success"><Trans>Active</Trans></Badge> : <Badge className="bg-danger"><Trans>Non Active</Trans></Badge>}</td>
                                                            <td><Link to={`/vehicle-categories/edit/${vehicle_category.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={`/vehicle-categories/remove/${vehicle_category.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br></br>
                                    <div className="text-center">
                                        {/* Pagination controls */}
                                        <button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
                                            <Trans>Previous</Trans>
                                        </button>&nbsp;
                                        <button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
                                            <Trans>Next</Trans>
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )
}

export default VehicleCategoriesList
